module.exports = __webpack_public_path__ + "img/orangedown.a6fdd10c.png";